<template>
  <p className="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT  © {{ new Date().getFullYear() }}
      <b-link
          className="ml-25"
          href=""
          target="_blank"
          rel="nofollow"
      >Lobitozz</b-link>
      <span class="d-none d-sm-inline-block">, All rights Reserved</span>
    </span>

    <span class="float-md-right d-none d-md-block">Designed with
      <feather-icon
          icon="HeartIcon"
          className="text-danger fill-current w-4 h-4"
      />
      by Comextweb S.A.
    </span>

  </p>
</template>

<script>
import {BLink} from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
<style>
footer.footer span svg {
  margin-left: 0 !important;
}
</style>
